<template>
	<v-card elevation="0" class="rounded-lg pa-2" color="#F5F6F9">
		<div class="text-center pt-2 d-flex justify-center">
			<v-img v-if="loan.base64" :src="loan.base64" width="135px" />
			<v-icon v-else size="100" color="grey">mdi-account-cash</v-icon>
		</div>
		<v-sheet class="pa-1 rounded-md" color="white" style="min-height: 90px;">
			<div class="text-right pa-2" style="overflow: hidden;height: 60px;">{{ loan.planTitle }}</div>
			<div class="d-flex flex-wrap">
				<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.profitPercent">بدون سود</v-chip>
				<v-chip class="mx-2" color="#e7fee8" x-small v-else>سود: {{ loan.profitPercent }}</v-chip>
				<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.delayPercent">بدون جریمه</v-chip>
				<v-chip class="mx-2" color="#e7fee8" x-small v-if="!!loan.earlyPercent">سود زودکرد</v-chip>
				<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.maxAmount">بدون سقف</v-chip>
				<v-chip class="mx-2" color="#e7fee8" x-small v-if="!loan.allowedInstallments">بازپرداخت دلخواه</v-chip>
				<v-chip class="mx-2" color="#ffccdd" x-small v-if="loan.disable">غیر فعال</v-chip>
			</div>
		</v-sheet>
	</v-card>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'PlanGridItem',
		props: {
			loan: {
				type: Object,
			},
		},
		data: () => ({}),
		computed: {

		},
	}
</script>
